import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import EmailInfoComp from 'areas/admin/emailingLog/emailInfo/EmailInfoComp';

class EmailInfoModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	open = (params) => {
		this.setState({
			visible: true,
			modalTitle: params.modalTitle,
			emailKey: params.emailKey
		});
	}

	close = () => {
		this.setState({
			visible: false,
		});
	}

	initialState = () => {
		return {
			params: {},
			callbacks: {},
			visible: false,
			form: {},
		};
	}

	handleCancel = () => {
		this.close();
	}

	// React
	render() {
		if (!this.state.visible) return null;

		return (
			<Modal
				show={this.state.visible}
				onHide={this.handleCancel}
				dialogClassName="modal-70w"
			>
				<Modal.Header closeButton>
					<Modal.Title>{this.state.modalTitle}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<EmailInfoComp emailKey={this.state.emailKey} />
				</Modal.Body>
				<Modal.Footer>
						<Button variant="default" onClick={this.handleCancel}>Close</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

export default EmailInfoModal;



// WEBPACK FOOTER //
// ./src/areas/admin/sponsorSetup/notifications/EmailInfoModal.js